import { useQuery } from '@tanstack/react-query';

import { checkException, TError } from 'config/reactQuery';
import { useRef } from 'react';
import { familyApprovalTwoFaApi } from 'service/api/familyApprovalTwoFaApi';

export const useGetApprovalTransactionStatus = ({ pollingUrl }: { pollingUrl: string }) => {
  const familyApprovalTFAService = familyApprovalTwoFaApi();
  const pos = pollingUrl.indexOf('/rest');
  const url = pollingUrl.substring(pos);
  const abortControllerRef = useRef<AbortController | null>(null);

  const query = useQuery({
    queryKey: ['get-booking'],
    queryFn: async () => {
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      return familyApprovalTFAService.getKundanzuganTransactionStatus(url, signal);
    },
    select: (response) => response?.data,
    throwOnError: (error: TError) => checkException(error, false, true, true),
    enabled: false,
  });

  const getTransactionStatus = async () => {
    const res = await query.refetch();
    return res?.data;
  };

  return {
    ...query,
    getTransactionStatus,
  };
};
